



























































import { Component, Vue } from "vue-property-decorator";
import { mapActions, mapGetters } from "vuex";

// form validation
import { extend, setInteractionMode } from "vee-validate";
import { required, email, min, max } from "vee-validate/dist/rules";

setInteractionMode("eager");

@Component({
  computed: {
    ...mapGetters("profile", ["userProfile"])
  },
  methods: {
    ...mapActions(["loginUser"])
  }
})
export default class Login extends Vue {
  userProfile!: any;
  email = "";
  password = "";
  loginpassword = false;
  loadingLogin = false;

  created() {
    this.$store.dispatch("navbar", false);
  }

  submit() {
    this.loadingLogin = true;
    (this.$refs.loginObserver as Vue & {
      validate: () => any;
    })
      .validate()
      .then((isValid: boolean) => {
        if (isValid) {
          const info: any = {
            password: this.password
          };
          if (/[\w._%+-]+@[\w.-]+\.[a-zA-Z]{2,3}/.test(this.email))
            info.email = this.email;
          else info.name = this.email;

          this.$store
            .dispatch("users/loginUser", info)
            .then(res => {
              this.loadingLogin = false;
              console.log(
                "the pofile obj: ",
                Object.keys(this.userProfile).length
              );
              if (Object.keys(this.userProfile).length)
                this.$router.push({ name: "ProfileInfo" });

              this.$store.dispatch("navbar", true);
              this.$router.push({ name: "Dashboard" });

              this.$vs.notification({
                icon: "<i class='bx bx-bell' ></i>",
                color: "primary",
                position: "top-right",
                title: "Welcome",
                text: `Success: Welcome again ${this.userProfile.name} to axumhb`
              });
            })
            .catch((err: string) => {
              setTimeout(() => (this.loadingLogin = false), 2000);
              this.$vs.notification({
                icon: "<i class='bx bxs-bug' ></i>",
                color: "danger",
                position: "top-right",
                title: "Login Error",
                text: `Error: ${err}`
              });
            });
        } else {
          setTimeout(() => (this.loadingLogin = false), 2000);
        }
      })
      .catch((error: any) => {
        setTimeout(() => (this.loadingLogin = false), 2000);
      });
  }
}
